import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService {
  constructor(
    private router: Router,
    private tokenService: TokenService
  ) {}

  Token() {
    const Token = window.localStorage.getItem('token');
    return Token;
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = this.Token();

    if (!token) {
      this.router.navigate(['/']);
      return false;
    }

    // Vérifier si le token n'est pas expiré
    if (this.tokenService.isTokenExpired(token)) {
      localStorage.clear();
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
